export default __webpack_public_path__ + "static/media/flames.e9ecb1a0.gif";